
export enum DwellPeriodTypeCd {
	ANY = 'Any',
	ARRIVAL = 'Arrival',
	BETWEEN_TRIPS = 'BetweenTrips',
	DEPARTURE = 'Departure'}

